__turbopack_context__.v({
  "container": "ResultsMessage-module__d6Hlma__container",
  "content": "ResultsMessage-module__d6Hlma__content",
  "copy": "ResultsMessage-module__d6Hlma__copy",
});
